import { render, staticRenderFns } from "./footerPage.vue?vue&type=template&id=bca960c4&scoped=true"
import script from "./footerPage.vue?vue&type=script&lang=js"
export * from "./footerPage.vue?vue&type=script&lang=js"
import style0 from "./footerPage.vue?vue&type=style&index=0&id=bca960c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca960c4",
  null
  
)

export default component.exports